import { z } from "zod";

export const AuditActionSchema = z.enum([
  "create",
  "update",
  "delete",
  "import",
  "export",
  "clear",
]);

export const AuditSourceSchema = z.enum([
  "admin_api",
  "django_admin",
  "customer",
  "payment_provider",
  "system",
]);

const AuditValueSchema = z.unknown();

export const AuditFieldChangeSchema = z.object({
  before: AuditValueSchema,
  after: AuditValueSchema,
});

export const AuditResourceChangeSchema = z.object({
  resource_type: z.string(),
  resource_id: z.string(),
  fields: z.record(z.string(), AuditFieldChangeSchema),
});

export const AuditEntrySchema = z.object({
  id: z.string().uuid(),
  occurred_at: z.string(),
  event_type: z.string(),
  action: AuditActionSchema,
  source: AuditSourceSchema,
  actor: z
    .object({
      id: z.number(),
      email: z.string().email(),
    })
    .nullable(),
  actor_email: z.string(),
  resource_type: z.string(),
  resource_ids: z.array(z.string()),
  changes: z.array(AuditResourceChangeSchema),
  metadata: z.record(z.string(), z.unknown()),
});

export const AuditStatsSchema = z.object({
  entry_count: z.number(),
  logical_size_bytes: z.number(),
});

export const AuditClearResponseSchema = z.object({
  deleted_count: z.number(),
  receipt_id: z.string().uuid(),
  entry_count: z.number(),
  logical_size_bytes: z.number(),
});

export type AuditAction = z.infer<typeof AuditActionSchema>;
export type AuditSource = z.infer<typeof AuditSourceSchema>;
export type AuditEntry = z.infer<typeof AuditEntrySchema>;
export type AuditResourceChange = z.infer<typeof AuditResourceChangeSchema>;
export type AuditStats = z.infer<typeof AuditStatsSchema>;
export type AuditClearResponse = z.infer<typeof AuditClearResponseSchema>;
